export default __webpack_public_path__ + "ec8f7a69f64f7b7a6d842a76eedfab8d.svg";